// create by nieshu on 2018/11/5
// config
// import ETC from '../config/etc.config'
// utils
import Util from '@/utils/util'
// import cmblapi from '@etc/cmblapi'
import MD5 from 'crypto-js/md5'
// api
// import NewApplyApi from '@/api/newApply.api'

const MobileDetect = require('mobile-detect')

// 插件
class Plugins {
  static locationDefer = Util.createDefer()
  static systemDefer = Util.createDefer()
  static zhaoJSDefer = Util.createDefer()
  static appStartDefer = Util.createDefer()

  /**
   * 获取手机信息
   * brand 手机品牌 1.5.0
   * model 手机型号
   * screenWidth 屏幕宽度 1.1.0
   * screenHeight 屏幕高度 1.1.0
   * windowWidth 可使用窗口宽度
   * windowHeight 可使用窗口高度 system 操作系统版本
   * platform 客户端平台
   * @returns {*}
   */
  static getSystemInfo() {
    // const APP_EVN = localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL)
    const md = new MobileDetect(window.navigator.userAgent)
    let info = {
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      windowWidth: window.screen.availWidth,
      windowHeight: window.screen.availHeight,
      os: md.os(),
      phone: md.phone(),
      model: md.mobile(),
      isIOS: md.is('iOS'),
      isAndroid: md.os() === 'AndroidOS'
    }
    if (info.isIOS) {
      let h = window.innerHeight
      if (h >= 812 || h === 724) {
        info.isIphoneX = true
      }
    }
    // APP.SYSTEM_INFO = info
    this.systemDefer.resolve(info)
    return this.systemDefer.promise
  }

  /**
   * 获取地理位置
   */
  static getLocation(appChannel) {
    // const APP_EVN = localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL)
    let self = this
    if (appChannel === 'qqmap') {
      this.locationDefer.resolve({latitude: '', longitude: ''})
    } else if (appChannel === 'zhaohang') {
      setTimeout(() => {
        this.locationDefer.resolve({latitude: '', longitude: ''})
      }, 5000)
      window.CMBLS.gps = window.CMBLS.gps || {};
      window.CMBLS.gps.successCallback = function(id, message) {
        console.log('CMBLS gps调用成功');
        let msg = message
        try {
          msg = message
            .replace('<data>', '{').replace('</data>', '}')
            .replace('<stateCode>', '"stateCode":').replace('</stateCode>', ',')
            .replace('<latitude>', '"latitude":').replace('</latitude>', ',')
            .replace('<longitude>', '"longitude":').replace('</longitude>', ',')
            .replace('<province>', '"province":').replace('</province>', ',')
            .replace(/(<[a-zA-Z]+>)\S+(<\/[a-zA-Z]+>)/g, '').replace(',}', '}')
          msg = JSON.parse(msg)
        } catch (e) {
        } finally {
          self.locationDefer.resolve(msg)
        }
      };
      window.CMBLS.gps.failCallback = function(id, message) {
        console.log('CMBLS gps调用失败', message)
        self.locationDefer.reject(message)
      };
      window.cmblsJSExecutor('http://CMBLS/gps?id=123')
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.locationDefer.resolve(position.coords)
      }, err => {
        this.locationDefer.reject(err)
      }, {
        timeout: 10000
      })
    } else {
      this.locationDefer.reject('no geolocation')
    }
    return this.locationDefer.promise
  }

  /**
   * 下载图片
   */
  downloadImage() {}
// 已不可使用
  // static zhaohangLogin(corpNo, secretKey) {
  //   console.log('zhaohangLogin', corpNo)
  //   return new Promise(re => {
  //     let timestamp = Util.dateFormat(new Date(), 'yyyyMMddhhmmss')
  //     let nonceStr = Util.randomString(16)
  //     let sign = MD5(corpNo + timestamp + nonceStr + secretKey).toString()
  //     // console.log('timestamp', timestamp)
  //     // console.log('nonceStr', nonceStr)
  //     // console.log('md5', corpNo + timestamp + nonceStr + secretKey)
  //     // console.log('sign', sign)
  //     cmblapi.merchantLogin({
  //       corpNo,
  //       reAuth: false,
  //       authInfo: {
  //         timestamp,
  //         nonceStr,
  //         sign
  //       },
  //       success: (res) => {
  //         console.log('zhaohangLogin success', res)
  //         // res结果如下:
  //         // {body ="xxx",cryptType = 2,resultType = Y}
  //         re(res)
  //       },
  //       fail: (res) => {
  //         console.log('zhaohangLogin fail', res)
  //         re(false)
  //       }
  //     })
  //   })
  // }

  static zhaoLogin() {}
}

export default Plugins
